import { ReportsServiceAPI } from '@API/data-services/reports-service'
import { WeeklyReport } from '../weekly-report'

export const ClaimsReports = () => {
  return (
    <WeeklyReport
      title="Claims Reports"
      downloads={[
        { label: 'Summary', fetchReportUrl: ReportsServiceAPI.getClaimsSummaryReportUrl },
      ]}
    />
  )
}
